import { createAsyncThunk } from '@reduxjs/toolkit';
import { toastHandler } from '../../../utils/toastHandler';
import { CreateCampaignLead, GetCampaign, UpdateCampaignLead } from './interface';
import { CampaignLeads, Campaigns } from '../../../client/services';

export const createCampaignLead = createAsyncThunk(
  'nfadaCampaign/createCampaignLead',
  async (values: CreateCampaignLead, { rejectWithValue }) => {
    try {
      const response = await CampaignLeads.create(values);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  },
);

export const getCampaign = createAsyncThunk(
  'nfadaCampaign/getCampaign',
  async ({ code }: GetCampaign, { rejectWithValue }) => {
    try {
      const response = await Campaigns.get(code);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  },
);

export const updateCampaignLead = createAsyncThunk(
  'nfadaCampaign/updateCampaignLead',
  async ({ id, ...values }: UpdateCampaignLead, { rejectWithValue }) => {
    try {
      const response = await CampaignLeads.patch(id, values);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  },
);
